module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/redzel.e5f1f06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/redzel.jpg
// module id = XACR
// module chunks = 0